var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h5',{staticClass:"titulo text-center"},[_vm._v(_vm._s(_vm.title))]),_c('bar-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.chartOptions,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }